import { useQuery } from '@tanstack/react-query';
import { get } from '../../utils/networking';

interface SlackChannel {
  id: string;
  name: string;
  isPrivate: boolean;
}

export interface SlackWorkspace {
  id: number;
  workspaceId: string;
  workspaceName: string;
  channels: SlackChannel[];
  installedAt: string;
}

interface GetSlackWorkspacesResponse {
  workspaces: SlackWorkspace[];
}

const getSlackWorkspaces = async (): Promise<GetSlackWorkspacesResponse> => {
  return get<GetSlackWorkspacesResponse>('/api/integrations/slack/workspaces');
};

export const useGetSlackWorkspaces = () => {
  return useQuery({
    queryKey: ['slack-workspaces'],
    queryFn: getSlackWorkspaces,
  });
};
